import { render, staticRenderFns } from "./goodsManageIndex.vue?vue&type=template&id=3d6a7b37&scoped=true&"
import script from "./goodsManageIndex.vue?vue&type=script&lang=js&"
export * from "./goodsManageIndex.vue?vue&type=script&lang=js&"
import style0 from "./goodsManageIndex.vue?vue&type=style&index=0&id=3d6a7b37&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d6a7b37",
  null
  
)

export default component.exports